import Floor from "../../Floor/Floor.js";
import Navigator from "../../Navigator.js";
import Space from "../Space.js";
import NavigatorRouter from "@modules/navigator/Navigator.router.js";

const SpaceSelect = {
    options: {},
    index: 0,

    init() {
        this.el = $('[component="SpaceSelect"]');
        if (!this.el.length) return;

        this.nav = this.el.find('.nav');
        this.buttons = this.nav.find("button");

        this.flats = Navigator.isPriceListPage() ? NAVIGATOR_DATA.flats : Floor.data.flats;
        this.options = this.getOptions();
        this.current = Space.data.name;
        this.index = this.options.indexOf(this.current);
        this.min = 0;
        this.max = Object.keys(this.options).length - 1;

        this.bind();
        this.arrangeButtons();
    },

    bind() {
        this.buttons.unbind("click").click((evt) => {
            const direction = parseInt($(evt.currentTarget).attr('direction'), 10);

            if (this.index === 0 && direction === -1) return;
            if (this.index === this.max && direction === 1) return;

            this.index = this.index + direction;
            this.current = this.options[this.index];

            this.setValue(this.current);
        });
    },

    setValue(nmb) {
        NavigatorRouter.setSpace(nmb);

        this.arrangeButtons();
    },

    arrangeButtons() {
        this.nav.removeClass('start end');

        if (this.index === 0) {
            this.nav.addClass('start');
        }

        if (this.index === this.max) {
            this.nav.addClass('end');
        }
    },

    getOptions() {
        const filtered = Object.fromEntries(
            Object.entries(this.flats)
                .filter(([key, flat]) => Space.isAvailable(flat))
                .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
        );

        return Object.keys(filtered);
    }
}
export default SpaceSelect;